import $ from 'jquery';
import { showBodyMask, hideBodyMask } from '../body-mask/c-body-mask';

function initDesktopMenu() {
    // Define main element and early return
    const $desktopMenu = $('.c-desktop-menu');
    if (!$desktopMenu.length) { return; }

    // Declare function vars
    const $subClose = $desktopMenu.find('.js-submenu .js-close-submenu');
    const $menuItem = $desktopMenu.find('.menu-item');

    // Display submenu and mask when mouse hover the menu item
    $menuItem.on('mouseenter touchstart', e => {
        // if there is a sub menu then show it, if not remove the mask and current menus
        // IF subnav is already showing, we do the switch staight away, otherwise wait half a sectond to be sure
        if (e.currentTarget.querySelector('.js-submenu')) {
            if ($('.c-desktop-menu .menu-item .js-submenu.block-display').length) {
                openSubnavIfHovered();
            } else {
                setTimeout(() => {
                    openSubnavIfHovered();
                }, 500);
            }
        } else {
            hideBodyMask();
            $subClose.click();
        }
    });

    // Remove the block display when the cross is pressed on the submenu
    $subClose.click(function () {
        const $submenus = $(this).closest('.menu-item').find('.js-submenu');
        $submenus.removeClass('block-display');
        hideBodyMask();
    });
}

function openSubnavIfHovered() {
    const $menuItem = $('.c-desktop-menu .menu-item');
    const $hoveredMenuItem = $('.c-desktop-menu .menu-item:hover');
    if (!$menuItem.length || !$hoveredMenuItem.length) { return; }

    const $submenus = $hoveredMenuItem.find('.js-submenu');
    $menuItem.find('.js-submenu').removeClass('block-display');
    $submenus.addClass('block-display');
    showBodyMask();
}

export default function closeDesktopNav() {
    const $subMenu = $('.c-desktop-menu .js-submenu');
    if (!$subMenu.length) { return; }

    $subMenu.removeClass('block-display');
}

// Kick off the init on document ready
$(() => {
    initDesktopMenu();
});



// WEBPACK FOOTER //
// ./src/components/desktop-menu/c-desktop-menu.js